import { Fade } from '@mui/material';
import tableToolRenderer from '../toolRenderers/tableToolRenderer';
import userActionsToolRenderer from '../toolRenderers/userActionsToolRenderer';
import lineageGraphToolRenderer from '../toolRenderers/lineageGraphToolRenderer';
import {
  ToolRendererArgs,
  OnUserInteraction,
  ToolRendererUserSelectedValue,
} from '../types';
import AppNavigationToolRenderer from '../toolRenderers/AppNavigationToolRenderer';

type ToolRendererEntry = {
  render: (
    toolArgs: ToolRendererArgs,
    onUserInteraction?: OnUserInteraction,
    selectedValue?: ToolRendererUserSelectedValue,
    isActive?: boolean,
  ) => JSX.Element;
  expandable?: boolean;
};

const rendererMap: Record<string, ToolRendererEntry> = {
  table_display: { render: tableToolRenderer, expandable: true },
  user_actions_display: { render: userActionsToolRenderer },
  app_navigation: { render: AppNavigationToolRenderer },
  lineage_graph_display: { render: lineageGraphToolRenderer, expandable: true },
};

export const hasFEToolRenderer = (toolName?: string): boolean =>
  !!toolName && toolName in rendererMap;

export const isFEToolExpandable = (toolName: string): boolean =>
  rendererMap[toolName]?.expandable === true;

type Props = {
  toolName?: string;
  toolArgs?: ToolRendererArgs;
  onUserInteraction?: OnUserInteraction;
  selectedValue?: ToolRendererUserSelectedValue;
  isActive?: boolean;
};

const FEToolRenderer = ({
  toolName = '',
  toolArgs = {},
  onUserInteraction,
  selectedValue,
  isActive,
}: Props) => (
  <Fade in>
    <div>
      {rendererMap[toolName]?.render(
        toolArgs,
        onUserInteraction,
        selectedValue,
        isActive,
      )}
    </div>
  </Fade>
);

export default FEToolRenderer;
